// Competitor badge — team logo when the feed carries one (archive imports
// carry thesportsdb badge URLs), monogram fallback otherwise (the live seed
// fixtures ship no logos; prod aggregator data does).

import { useState } from 'react';
import type { Competitor } from '../feed';

export function TeamBadge({
  competitor,
  className = 'h-7 w-7 text-[10px]',
}: {
  competitor: Competitor;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const label = competitor.symbol || competitor.shortName || competitor.name;

  if (!competitor.logoUrl || failed) {
    return (
      <span
        aria-hidden="true"
        className={`inline-flex shrink-0 items-center justify-center rounded-full bg-primary/20 font-semibold text-primary ${className}`}
      >
        {label.slice(0, 3)}
      </span>
    );
  }

  return (
    <img
      src={competitor.logoUrl}
      alt={competitor.name}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`shrink-0 object-contain ${className}`}
    />
  );
}
